import ReactDOM from "react-dom";
import "./index.css";
import silverCoin from "./silvercoin.png";

interface ModalProps {
  text: string;
  textBtnLeft: string;
  textBtnRight: string;
  prise?: boolean;
  onClickLeft?: () => void;
  onClickRight: () => void;
}

export function Modal(props: ModalProps) {
  let onClickCloseModal;
  if (props.prise) {
    onClickCloseModal = props.onClickRight;
  } else {
    onClickCloseModal = props.onClickLeft;
  }

  return ReactDOM.createPortal(
    <>
      <div className="overlayModal" onClick={onClickCloseModal}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-textConteiner">
            <p>{props.text}</p>
          </div>
          <div className="onwardBtnLess modal-btn">
            {props.textBtnLeft === "" ? (
              <div
                className="mainContentSurveyLesson-skipButton"
                onClick={props.onClickRight}
              >
                {props.textBtnRight}
              </div>
            ) : (
              <>
                <div
                  className="mainContentSurveyLesson-sendButton"
                  onClick={props.onClickLeft}
                >
                  {props.prise === true ? (
                    <>
                      {props.textBtnLeft}
                      <div className="textBtnLeftWithoutCoin">
                        <img src={silverCoin} alt=""/>
                        -20
                      </div>
                    </>
                  ) : (
                    props.textBtnLeft
                  )}
                </div>
                <div
                  className="mainContentSurveyLesson-skipButton"
                  onClick={props.onClickRight}
                >
                  {props.textBtnRight}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>,
    document.getElementById("react-id") as HTMLElement
  );
}
